import { RenderOnlyProductsAndCustoms } from '../shared';

import { useOutOfStock } from './hooks';

import type {
  FullMenuCatalog,
  IMenuCustomization,
  IMenuProduct,
  MenuOutOfStock,
} from 'features/menu-page/domain';

export function OutOfStock(props: Props) {
  const {
    catalog,
    outOfStock,
    toggleOnOffProduct,
    toggleOnOffCustomization,
  } = props;

  const { lang } = useOutOfStock();

  return (
    <RenderOnlyProductsAndCustoms
      title={lang.title}
      ariaLabel='disabled-items'
      isModeOutOfStock={true}
      catalog={catalog}
      products={outOfStock.products}
      customizations={outOfStock.customizations}
      toggleOnOffProduct={toggleOnOffProduct}
      toggleOnOffCustomization={toggleOnOffCustomization}
    />
  );
}

interface Props {
  catalog: FullMenuCatalog;
  outOfStock: MenuOutOfStock;
  toggleOnOffProduct: (c: boolean, p: IMenuProduct) => void;
  toggleOnOffCustomization: (c: boolean, item: IMenuCustomization) => void;
}
